import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack } from '@mui/material';

import Modal from 'src/components/common/Modal';

interface RevertActionPhaseModalProps {
  showModal: boolean;
  onClose: () => void;
  handleDelete: () => void;
}
const RevertActionPhaseModal: React.FC<RevertActionPhaseModalProps> = ({
  showModal,
  onClose,
  handleDelete,
}) => {
  const { t } = useTranslation(['planAction', 'common']);

  return (
    <Modal
      headline={t('planAction:ActionPlan.RevertActionPhaseWarning.Headline')}
      message={t('planAction:ActionPlan.RevertActionPhaseWarning.Warning')}
      isOpen={showModal}
      onClose={onClose}
    >
      <Stack direction="row" spacing={2}>
        <Button variant="cta" color="secondary" fullWidth onClick={onClose}>
          {t('common:cancel')}
        </Button>

        <Button
          variant="cta"
          fullWidth
          data-test-id="revert-action-phase-button"
          onClick={handleDelete}
        >
          {t('common:confirm')}
        </Button>
      </Stack>
    </Modal>
  );
};

export default RevertActionPhaseModal;
